/**
 * Created by FENGSB on 2015/8/24.
 */
/* eslint-disable */
require('./fixed-toolbar-dir.scss');

import urlTemp from './fixed-toolbar-dir.html';

angular.module('RCP').directive("fixedToolbar", function() {
    return {
        template: urlTemp,
        restrict: "E",
        replace: true,
        transclude: true,
        scope: {
            data: "=data"
        },
        controller: function($scope, $rootScope, $timeout, service, chatGlobal) {
            $scope.f = {
                consult: '找客服聊天',
            };
            $scope.h = {
                listCustomService: '获取客服列表',
            };
            $timeout(function() {
                $scope.currentUser = $rootScope.currentUser;
            }, 0);
            $scope.d = {
                //客服列表
                customList: [],
                isIE9: rcpAid.isIE(9, 9)
            };

            function init() {
                // $(window).bind('scroll', handler);
                // $(window).bind('resize', handler);
                if (!$scope.data) {
                    // 从localStorage读取
                    $timeout(function() {
                        var temData = angular.fromJson(localStorage.headerFooterData) || {};
                        $scope.d.isIE9 = rcpAid.isIE(9, 9);
                        $scope.d.qr = temData.qrAppDown || {};
                        $scope.d.qr.src = rcpAid.safe($scope.d, 'qr.img', '');
                        $scope.d.wx = rcpAid.safe(temData, 'twoDimensionCode', {});
                        $scope.d.wx.src = rcpAid.safe($scope.d, 'wx.img', '');
                    }, 500);
                } else {
                    $scope.d = $scope.data;
                    $scope.d.isIE9 = rcpAid.isIE(9, 9);
                }
                if (rcpAid.safe($scope.d, 'qr.name')) {
                    $scope.d.qr.name = decodeURI($scope.d.qr.name);
                }
                if (rcpAid.safe($scope.d, 'wx.name')) {
                    $scope.d.wx.name = decodeURI($scope.d.wx.name);
                }
                // handler();
                $scope.h.listCustomService();
            }
            //显示隐藏回到顶部
            function handler() {
                var elem = $('.to-top');
                var top = $(window).scrollTop();
                if (top > 300) {
                    elem.addClass('visible');
                } else {
                    elem.removeClass('visible');
                }
            }

            //func
            /**
             * 找客服聊天
             * @param  {[type]} argData [客服信息]
             * @return {[type]}         [description]
             */
            $scope.f.consult = function(argData) {
                var temUid = '';
                if (argData) {
                    temUid = argData.id;
                } else if ($scope.d.customList.length === 1) {
                    temUid = rcpAid.safe($scope.d.customList, '0.id');
                }
                if (temUid) {
                    service.chatGlobal.chatById(temUid);
                }
            };
            //http
            /**
             * 获取客服列表
             * @return {[type]} [description]
             */
            $scope.h.listCustomService = function() {
                var data = {
                    count: 100,
                };
                service.common.listCustomService(data).then(function(rs) {
                    $scope.d.customList = [];
                    $scope.d.customList = rs.data;
                }, function(e) {
                    service.dialog.showErrorTip(e, { moduleName: 'fixed-toolbar-dir', funcName: 'listCustomService' });
                });
            };
            init();
        }
    };
});


// WEBPACK FOOTER //
// ./src/recruit/src/directive/fixed-toolbar/fixed-toolbar-dir.js